const autoNgTemplateLoaderTemplate1 = require('./license-expiration-panel.html');

import controller from './license-expiration-panel.controller.js';
import './license-expiration-panel.css';

export const licenseExpirationPanel = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
};
